// extracted by mini-css-extract-plugin
export var addButton = "_n0-0";
export var border = "_n0-8";
export var check = "_n0-h";
export var danger = "_n0-6";
export var dropdownContainer = "_n0-1";
export var editModalBody = "_n0-j";
export var footerContainer = "_n0-i";
export var fullWidth = "_n0-a";
export var hide = "_n0-9";
export var icon = "_n0-3";
export var input = "_n0-7";
export var inputFlex = "_n0-b";
export var inputWrapper = "_n0-c";
export var manualFocus = "_n0-5";
export var optionButton = "_n0-4";
export var pillWrapper = "_n0-e";
export var pointer = "_n0-2";
export var showOverflow = "_n0-f";
export var tagsFlex = "_n0-d";
export var xButton = "_n0-g";